module.exports = __webpack_public_path__ + "static/media/chat_group.063a415c.png";